import { de } from '@/i18n/de';
import { cn } from '@/shell/lib/cn';
import { InternalLink } from '@/shell/ui/internal-link';
import { MoreMenu } from './more-menu';
import { isActive, MOBILE_MORE_NAV, MOBILE_NAV } from './nav';

/**
 * Untere Leiste auf dem Handy: vier Ziele plus „Mehr“, je Symbol über Wort, mindestens 44 px hoch, mit
 * Sicherheitsabstand für Geräte mit Gestenleiste.
 */
export function BottomBar({ pathname }: { pathname: string }) {
  return (
    <nav
      aria-label={de.nav.labelMobile}
      className="sticky bottom-0 z-30 flex border-t border-line bg-surface-block pb-[env(safe-area-inset-bottom)]"
    >
      {MOBILE_NAV.map(({ id, href, label, Icon }) => {
        const active = isActive(pathname, href);
        return (
          <InternalLink
            key={id}
            href={href}
            current={active}
            className={cn(
              'flex min-h-14 min-w-0 flex-auto flex-col items-center justify-center gap-0.5 border-t-[3px] px-1 text-fine',
              active ? 'border-accent font-bold text-ink' : 'border-transparent text-ink-muted',
            )}
          >
            <Icon aria-hidden="true" className="size-6" />
            <span>{label}</span>
          </InternalLink>
        );
      })}
      <MoreMenu items={MOBILE_MORE_NAV} stacked />
    </nav>
  );
}
